import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ViewWrapper } from '@/components/viewWrapper/ViewWrapper.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { GeneralErrorTitleStyles } from '@/views/generalError/generalError.styles.ts';

interface Props {
  message: string;
  subMessage?: string;
}

export const GeneralError: React.FC<Props> = props => {
  const { message, subMessage } = props;
  const { t } = useTranslationWithPrefix('generalError');

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <>
      <ViewWrapper>
        <Typography sx={GeneralErrorTitleStyles} variant="f24Medium">
          <ErrorIcon />
          {t('title')}
          <ErrorIcon />
        </Typography>
        <Divider />
        <Typography variant="f16Regular">
          <Box sx={{ pt: 8, textAlign: 'center' }}>{message}</Box>
          {subMessage && <Box sx={{ pt: 4, textAlign: 'center' }}>{subMessage}</Box>}
        </Typography>
        <Grid
          container
          spacing={4}
          sx={{
            justifyContent: 'center',
            pt: 8,
          }}
        >
          <Grid>
            <Button onClick={handleGoBack} variant="outlined">
              {t('goBack')}
            </Button>
          </Grid>
        </Grid>
      </ViewWrapper>
    </>
  );
};
